import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _OverflowItem$context;

import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { overflowGroupNamespace, shouldReportItemHeight } from './shared-variables';

var OverflowItem = function (_Component) {
  _inherits(OverflowItem, _Component);

  function OverflowItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OverflowItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OverflowItem.__proto__ || _Object$getPrototypeOf(OverflowItem)).call.apply(_ref, [this].concat(args))), _this), _this.measureHeight = function (ref) {
      if (ref) {
        _this.context[overflowGroupNamespace].reportItemHeightToGroup(_this.props.overflowItemIndex, ref.clientHeight);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OverflowItem, [{
    key: 'render',
    value: function render() {
      if (!this.context[overflowGroupNamespace].shouldRenderItem(this.props.overflowItemIndex)) {
        return null;
      }

      if (this.context[shouldReportItemHeight]) {
        return React.createElement(
          'div',
          { ref: this.measureHeight },
          this.props.children
        );
      }

      return this.props.children;
    }
  }]);

  return OverflowItem;
}(Component);

OverflowItem.contextTypes = (_OverflowItem$context = {}, _defineProperty(_OverflowItem$context, overflowGroupNamespace, PropTypes.object), _defineProperty(_OverflowItem$context, shouldReportItemHeight, PropTypes.bool), _OverflowItem$context);
export default OverflowItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/overflow/OverflowItem.js
// module id = 707
// module chunks = 0